import axios from "../../privateApi";

export interface FeaturebaseJwtResponse {
  jwt: string;
}

export const getFeaturebaseJwt = async (): Promise<FeaturebaseJwtResponse> => {
  const response = await axios.post("/auth/featurebase-jwt");
  return response.data;
};
